(function($) {

	'use strict';

	var scrolled = false;

	var $grid = $('.masonry-grid');

	var offsetMasonry = 9;

	var init = function() {

		if($('.masonry-grid').length > 0) {

			setTimeout(function() {

				masonryLayout();

				$grid.masonry('on', 'layoutComplete', function() {
					$('.masonry-grid').addClass('visible');
				});

				popupTrigger();

			}, 300);

		}

    };
    
    var masonryLayout = function() {
		
		$grid.masonry({
			columnWidth: '.grid-sizer',
			gutter: '.gutter-sizer',
			itemSelector: '.grid-item',
			stamp: '.stamp',
			percentPosition: true,
			initLayout: false,
		});

		$(window).scroll(function() {

			var windowScroll = $(window).scrollTop();

			var footerOffset = $('footer').offset().top;

			var windowHeight = $(window).height();

			if(!scrolled && windowScroll >= footerOffset - windowHeight - 40) {

				masonryAjax();
				
				scrolled = true;
			}
		});

	}
	
	var masonryAjax = function(){

        jQuery.post(
            MyAjax.ajaxurl,
            {
                'action': 'infinite_scroll_masonry',
				'offset': offsetMasonry,
				'page-id': $('.masonry-grid').data('page-id'),
            },
            function(response){

				if(response != 'false'){

					var $items = $(response);

					$grid.append($items).masonry('appended', $items);

					offsetMasonry += 9;

					setTimeout(function() {
						scrolled = false;
					}, 100);

				}

            }
        );

	};

	var popupTrigger = function() {

		var top = 0;

		var video = [];

		$grid.masonry('on', 'layoutComplete', function() {

			video = document.getElementsByClassName("video-iframe");
		
			$('.popup-trigger').each(function() {

				$(this).unbind();

				$(this).click(function() {
					
					if($(this).parentsUntil('.popup-parent').find('.popup').hasClass('active') == true) {
						$(this).parentsUntil('.popup-parent').find('.popup').removeClass('active');
							setTimeout(function() {
								$('body').toggleClass('open');
								$('.join-us').toggleClass('body-is-open');
								$('html, body').scrollTop(top);
							}, 450);
	
							for (var i=0; i<video.length; i++) {
								video.item(i).contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
							}
	
						setTimeout(function() {
							$('.popup-opener').each(function() {
								$(this).removeClass('active');
							});
						}, 50);
					}
				})
			});

			$('.popup-opener').each(function(index) {

				$(this).click(function() {
					
					if($(this).hasClass('active') == false) {
						$(this).find('.popup').addClass('active');
						$(this).addClass('active');
							top = $(window).scrollTop();
							$('body').toggleClass('open');
							$('.join-us').toggleClass('body-is-open');
							$('body').scrollTop(top);

							setTimeout(function() {
								video.item(index).contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
							}, 450);

					}
				})
			});
			
		});

		$grid.masonry();

    }

	$(document).ready(function() {

		init();

	});

})(jQuery);